const getTopLevelChapterIds = (state) => state.story.topLevelChapters;
export default getTopLevelChapterIds;
